import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { moveCursorTo } from '../../../store/cursor'
import { setSyncHash, selectSyncStatus } from '../../../store/sync'
import { doRemoteImport, doRemoteExport, checkSync } from '../../../controllers/sync/remoteImportExport'
import { ServerUrlInput } from './ServerUrlInput'

export const RemoteImportExportComponent = (props) => {
    const [saveStatus, setSaveStatus] = useState('unsaved')
    const [loadStatus, setLoadStatus] = useState('unloaded')
    const [newChangesOnServer, setNewChangesOnServer] = useState(false)

    useEffect(() => {
        checkSync(props.history).then((syncStatus) => {
            if (syncStatus === 'conflict') {
                setNewChangesOnServer(true)
            }
        })
    })

    const remoteImport = () => {
        setLoadStatus('loading')
        doRemoteImport()
            .then(() => {
                setLoadStatus('unloaded')
                setNewChangesOnServer(false)
            })
            .catch((error) => {
                setLoadStatus('error')
                console.error(error)
                alert('Could not load data from server: ' + error.message)
            })
    }

    const remoteExport = () => {
        const tree = props.nodes
        const { cursorNodeId } = props
        const data = { tree, cursorNodeId }

        setSaveStatus('saving')

        doRemoteExport(data)
            .then(() => {
                setSaveStatus('saved')
                setNewChangesOnServer(false)
            })
            .catch((error) => {
                setSaveStatus('error')
                console.error(error)
            })
    }

    const syncStatusIndicator = () => {
        if (saveStatus === 'error' || loadStatus === 'error') {
            return (
                <>
                    <span style={{ color: 'red' }}> Error</span>
                    <br />
                    <br />
                </>
            )
        }

        if (props.saved && !newChangesOnServer) {
            return (
                <>
                    <span style={{ color: 'darkgreen' }}>All changes saved.</span>
                    <br />
                    <br />
                </>
            )
        }
    }

    const saveStatusIndicator = () => {
        if (saveStatus === 'saving') {
            return <span style={{ color: 'gray' }}> Saving...</span>
        }

        if (!props.saved) {
            return <b>You have unsaved changes.</b>
        }
    }

    const saveDataButton = () => {
        if (!props.saved) {
            return (
                <>
                    {saveStatusIndicator()}
                    <br />
                    <br />
                    <button id="remote-export-button" onClick={remoteExport}>
                        Save data to server
                    </button>
                    <br />
                    <br />
                </>
            )
        }
    }

    const loadStatusIndicator = () => {
        if (loadStatus === 'loading') {
            return <span style={{ color: 'gray' }}> Loading...</span>
        }

        if (newChangesOnServer) {
            return <b>New changes on sync server.</b>
        }
    }

    const loadDataButton = () => {
        if (newChangesOnServer) {
            return (
                <>
                    {loadStatusIndicator()}
                    <br />
                    <br />
                    <button id="remote-import-button" onClick={remoteImport}>
                        Load data from server
                    </button>
                    <br />
                    <br />
                </>
            )
        }
    }

    return (
        <div>
            <h3>Single user server (experimental)</h3>
            <ServerUrlInput />
            {syncStatusIndicator()}
            {saveDataButton()}
            {loadDataButton()}
        </div>
    )
}

const mapDispatchToProps = {
    moveCursorTo,
    setSyncHash
}

function mapStateToProps(state, _ownProps) {
    const syncStatus = selectSyncStatus(state)
    return {
        nodes: state.nodes,
        cursorNodeId: state.cursor.cursorNodeId,
        saved: syncStatus.saved,
        syncHash: state.sync.syncHash
    }
}

export const RemoteImportExport = withRouter(connect(mapStateToProps, mapDispatchToProps)(RemoteImportExportComponent))
